module.exports = __webpack_public_path__ + "img/hr-train-wheels-shadow-8.02ddd999.png";